import { HTMLAttributes, ReactNode, useEffect, useRef } from 'react';

interface ClickOutsideWrapperProps extends HTMLAttributes<HTMLDivElement> {
  onClickOutside: (event?: MouseEvent) => void;
  children: ReactNode;
  condition?: boolean;
  ignoreOutsideIds?: string[];
}

export const ClickOutsideWrapper = ({
  onClickOutside,
  children,
  condition = true,
  ignoreOutsideIds = [],
  ...props
}: ClickOutsideWrapperProps) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleClickOutside = (e: MouseEvent) => {
    if (
      wrapperRef.current &&
      !wrapperRef.current.contains(e.target as Node) &&
      condition
    ) {
      const target = e.target as Node;
      if (!document.getElementById('root')?.contains(target)) {
        return;
      }

      const allElements = document.querySelectorAll(
        '[data-prevent-click-outside="true"]',
      );
      const ignoredByIdElements = ignoreOutsideIds
        .map((id) => document.getElementById(id))
        .filter((el): el is HTMLElement => Boolean(el));

      const isInsideAny =
        Array.from(allElements).some((el) => el.contains(target)) ||
        ignoredByIdElements.some((el) => el.contains(target));

      if (!isInsideAny) {
        onClickOutside(e);
      }
    }
  };

  return (
    <div ref={wrapperRef} {...props}>
      {children}
    </div>
  );
};
